import { createAction } from 'typesafe-actions';

import { Specialty } from 'shared/types/filters/specialtyTypes';

export const changeSpecialtyTypesAction = createAction('filters/specialtyTypesChanged')<Specialty>();
export const setSpecialtyTypesAction = createAction('filters/setSpecialtyTypes')<Specialty[]>();
